var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontendmentor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.7344,
    y: 12.002,
    width: 1.99834,
    height: 18.1981,
    rx: 0.999168,
    fill: "#DDDDDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2454,
    y: 16.6077,
    width: 1.776,
    height: 10.2996,
    rx: 0.888001,
    transform: "rotate(65 39.2454 16.6077)",
    fill: "#DDDDDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9148,
    y: 21.7986,
    width: 1.776,
    height: 10.2996,
    rx: 0.888001,
    transform: "rotate(-65 29.9148 21.7986)",
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.3628C13.3478 34.54 21.7172 37.2182 27.8547 37.7539",
    stroke: "#DDDDDD",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontendmentor);
export default __webpack_public_path__ + "static/media/frontendmentor.a6f2614ca80b126309e36a6f6de9204b.svg";
export { ForwardRef as ReactComponent };